import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material'
import { BaseDialogComponent } from '../../../../base/dialog-base/dialog-base.component'
import { DialogService } from '../../../../services'

@Component({
	selector: 'atyl-confirm',
	templateUrl: './confirm.component.html',
	styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent extends BaseDialogComponent implements OnInit {

	clickSave: boolean = false;
	clickSaveClose: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<ConfirmComponent>,
		dialogService: DialogService,
		changeDetectorRef: ChangeDetectorRef,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		super(dialogRef, dialogService, changeDetectorRef)
	}

	ngOnInit() {
		console.log(this.data)
	}

	onClickSave() {
		this.clickSave = true
		this.clickSaveClose = true
	}

}
